<template>
  <r-avatar :icon="icon" :size="size" :color="color" :text-color="textColor" :font-size="fontSize" :rounded="rounded"/>
</template>

<script>
import RAvatar from '@/components/base/RAvatar';

export default {
  name: 'DefaultIcon',
  props: {
    icon: String,
    size: {
      type: String,
      default: 'xl',
    },
    color: {
      type: String,
      default: 'primary',
    },
    textColor: {
      type: String,
      default: 'riseup-beige',
    },
    fontSize: String,
    rounded: {
      type: Boolean,
      default: true,
    },
  },

  components: { RAvatar },
};
</script>
